import { Container, Grid, Paper, Typography } from '@mui/material';
import React from 'react';

const AboutScreen: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 8 }}>
            <Typography
                variant="h2"
                component="h1"
                textAlign="center"
                gutterBottom
                sx={{ fontWeight: 'bold', mb: 6 }}
            >
                About AI Solutions
            </Typography>

            <Paper elevation={2} sx={{ p: 6, backgroundColor: '#f8f9fa', mb: 6 }}>
                <Typography variant="h5" textAlign="center" sx={{ mb: 4, lineHeight: 1.6 }}>
                    With over 15 years of experience, we partner with organizations to unlock their full potential
                    through strategic insights, innovative solutions, and measurable results.
                </Typography>

                <Grid container spacing={4} sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 4 }} textAlign="center">
                        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1565c0' }}>
                            500+
                        </Typography>
                        <Typography variant="h6">Projects Completed</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }} textAlign="center">
                        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1565c0' }}>
                            98%
                        </Typography>
                        <Typography variant="h6">Client Satisfaction</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }} textAlign="center">
                        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1565c0' }}>
                            25+
                        </Typography>
                        <Typography variant="h6">Industry Experts</Typography>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container spacing={6}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                        Our Mission
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.8, mb: 3 }}>
                        To empower businesses with strategic insights and innovative solutions that drive sustainable growth
                        and competitive advantage in today's dynamic marketplace.
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
                        Our Approach
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                        We combine deep industry expertise with cutting-edge methodologies to deliver customized solutions
                        that address your unique challenges and unlock new opportunities for growth.
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    );
};

export default AboutScreen;